export default {
  translations: {
    'Try it out': 'Provalo',
    'Preview not available': 'Anteprima non disponibile',
    'New Board': 'Nuova tavola',
    'Import from .zip': 'Importa da .zip',
    'Importing...': 'Importazione...',
    'Failed to import board.': 'Impossibile importare la tavola.',
    'Create board on the tablet?': 'Creare la tavola sul tablet?',
    'Import board to the tablet?': 'Importare la tavola sul tablet?',
    "This board will be created in this user's tablet backup, not in your Portal boards. It will be sent to the tablet on the next sync.":
      'Questa tavola verrà creata nel backup del tablet di questo utente, non nelle tue tavole del Portale. Verrà inviata al tablet alla prossima sincronizzazione.',
    'Board title': 'Titolo della tavola',
    'Enter a title for the board': 'Inserisci un titolo per la tavola',
    'Card language': 'Lingua della carta',
    'Creating...': 'Creazione...',
    'Failed to create board.': 'Impossibile creare la tavola.',
    'Choose an image from the bank, generate one with AI or upload your own.':
      "Scegli un'immagine dalla banca, generane una con l'IA o carica la tua.",
    'Used for the symbol bank and speech (text-to-speech) of this board.':
      'Usato per la banca dei simboli e la voce (sintesi vocale) di questa tavola.',
    'How do you want to start?': 'Come vuoi iniziare?',
    'Blank board': 'Tavola vuota',
    'Start with tutorial': 'Inizia con il tutorial',
    'Create a board from scratch': 'Crea una tavola da zero',
    'Learn the studio with a ready-made board':
      'Impara lo studio con una tavola pronta',
    'Is this your first time creating boards?':
      'È la prima volta che crei tavole?',
    "Don't show this again": 'Non mostrare più',
    'Choose a title for your board': 'Scegli un titolo per la tua tavola',
    'Preview board': 'Anteprima della tavola',
    'Displayed text': 'Testo visualizzato',
    'Back and edit': 'Torna a modificare',
    SMALL: 'Piccolo',
    MEDIUM: 'Medio',
    LARGE: 'Grande',
    login: {
      welcome: 'Benvenuto su Livox!',
      error:
        'Impossibile accedere con i dati forniti. Email e/o password errati.',
      inactive_customer:
        'Il tuo account è stato disattivato. Contatta il supporto per assistenza.',
    },
    payment: {
      purchaseFor: 'Acquisto per',
      supportEmail: 'Email di contatto',
    },
    pm: {
      cards: 'Carte',
      manageYourPayment:
        'Gestisci le tue informazioni di pagamento. Per vedere i dettagli del tuo abbonamento mensile, vai su Abbonamenti.',
      defaultPayment: 'Pagamento predefinito',
      setAsDefault: 'Imposta come predefinito',
      addCard: 'Aggiungi carta',
      addBoleto: 'Aggiungi boleto',
      creditCard: 'Carta di Credito',
      boleto: 'Boleto',
      add: 'Aggiungi',
      boletos: 'Boletos',
    },
    paymentRegister: {
      title: 'Registrati per acquistare Livox',
      orLoginWithAccount: 'Hai già un account?',
      loginToComplete: "Accedi per completare l'acquisto",
      orRegisterNew: 'Oppure registrati per creare un nuovo account',
      holderAlreadyRegistered:
        'Un titolare è già registrato con questa email. Accedi al portale.',
      holderAlreadyRegisteredTitle: 'Titolare già registrato',
      holderAlreadyRegisteredMessage:
        'Un titolare è già registrato con questa email. Accedi al portale per accedere al tuo account.',
      holderAlreadyRegisteredMessageWithEmail:
        "Un titolare è già registrato con questa email. L'email {{email}} è già stata creata come titolare. Accedi al portale per accedere al tuo account.",
      goToLogin: 'Vai al login',
    },
    Role: 'Profilo',
    Often: 'Frequentemente',
    Sometimes: 'A volte',
    Never: 'Mai',
    Date: 'Data',
    CGQ: 'CGT',
    VIQ: 'VIS',
    AUQ: 'AUD',
    OLQ: 'CLO',
    BHQ: 'CMP',
    Overall: 'Generale',
    Actions: 'Azioni',
    'Holder Info': 'Informazioni sul Titolare',
    Loading: 'Caricamento',
    Profile: 'Profilo',
    Comments: 'Commenti',
    'View Branch': 'Visualizza Sede',
    'Add License to Branch': 'Aggiungi licenza alla sede',
    'Create Board': 'Crea Tabellone',
    'Review Publication': 'Rivedi Pubblicazione',
    Creator: 'Creatore',
    'Board History': 'Cronologia Tabelloni',
    'Change Customers to Support Area': "Sposta clienti all'area supporto",
    'Change Users to Support Area': "Sposta utenti nell'area supporto",
    'Change Licenses to Branch': 'Cambia licenze alla sede',
    'Tablet code': 'Codice del tablet',
    Back: 'Indietro',
    'Livox Store': 'Negozio Livox',
    Communication: 'Comunicazione',
    Leisure: 'Tempo libero',
    Feelings: 'Sentimenti',
    Hospital: 'Ospedale',
    Social: 'Sociale',
    'Daily Life': 'Vita Quotidiana',
    Foods: 'Alimentazione',
    School: 'Scuola',
    Education: 'Educazione',
    Literacy: 'Alfabetizzazione',
    Grammar: 'Grammatica',
    Geography: 'Geografia',
    Science: 'Scienze',
    History: 'Storia',
    Math: 'Matematica',
    Biology: 'Biologia',
    Fun: 'Divertimento',
    Stories: 'Storie',
    Games: 'Giochi',
    Game: 'Gioco',
    Memory: 'Memoria',
    'Questions and Answers': 'Domande e Risposte',
    'Popular Items': 'Articoli Popolari',
    'See more': 'Vedi di più',
    Code: 'Codice',
    'Last Modified': 'Ultima Modifica',
    'Upload from .zip': 'Carica da .zip',
    'My Boards': 'I miei Tabelloni',
    'My Portal Boards': 'I miei Tabelloni del Portale',
    'Welcome {{name}}, you have {{count}} licenses':
      'Benvenuto/a {{name}}, hai {{count}} licenze',
    'Publish one of your boards to share it with the Livox community.':
      'Pubblica una delle tue tabelle per condividerla con la comunità Livox.',
    'Welcome {{name}}, you have {{count}} users':
      'Benvenuto/a {{name}}, hai {{count}} utenti',
    'A-Z': 'A-Z',
    Size: 'Dimensione',
    Studio: 'Studio',
    Favorites: 'Preferiti',
    Keyboard: 'Tastiera',
    Import: 'Importa',
    Assign: 'Assegna',
    'Cover Art': 'Copertina',
    Title: 'Titolo',
    Description: 'Descrizione',
    Categories: 'Categorie',
    Submitter: 'Mittente',
    'Published at': 'Pubblicato il',
    View: 'Visualizza',
    'Pending Approval': 'In Attesa di Approvazione',
    'Holders Search': 'Ricerca Titolari',
    'Filter Status': 'Filtra Stato',
    'Audit Licenses': 'Verifica Licenze',
    'No Device': 'Nessun Dispositivo',
    'Livox Version': 'Versione di Livox',
    'Android Version': 'Versione di Android',
    'Last Validation At': 'Ultima Validazione il',
    Manage: 'Gestisci',
    Store: 'Negozio',
    Books: 'Libri',
    'Sign up': 'Registrati',
    Talk: 'Parla',
    Learn: 'Impara',
    Admin: 'Amministratore',
    'Store Admin': 'Admin del Negozio',
    'Discover new boards, games and stories':
      'Scopri nuove tavole, giochi e storie',
    'Search in store': 'Cerca nel negozio',
    'Search boards, games, stories...': 'Cerca tavole, giochi, storie...',
    'Recommended content': 'Contenuto consigliato',
    'Featured boards': 'Tavole in evidenza',
    'New content': 'Nuovo contenuto',
    'Featured creators': 'Creatori in evidenza',
    'Sort by': 'Ordina per',
    Downloads: 'Download',
    'Livox Community': 'Comunità Livox',
    'Total downloads': 'Download totali',
    'Community content': 'Contenuto della comunità',
    Follow: 'Segui',
    Following: 'Seguito',
    'View content': 'Vedi contenuto',
    Community: 'Comunità',
    Logout: 'Esci',
    'No description': 'Nessuna descrizione',
    'No Title': 'Senza titolo',
    New: 'Nuovo',
    'My content': 'I miei contenuti',
    'Unable to load your content': 'Impossibile caricare i tuoi contenuti',
    'Import board': 'Importa tavola',
    'Created by': 'Creato da',
    'Board tags': 'Tag della tavola',
    'No tags': 'Nessun tag',
    'Report content': 'Segnala contenuto',
    'Report reason': 'Motivo della segnalazione',
    Report: 'Segnala',
    'Report sent': 'Segnalazione inviata',
    'Failed to send report': 'Impossibile inviare la segnalazione',
    'Offensive content': 'Contenuto offensivo',
    'Inappropriate language': 'Linguaggio inappropriato',
    'Sexual or inappropriate content': 'Contenuto sessuale o inappropriato',
    Violence: 'Violenza',
    'Hate speech': 'Incitamento all’odio',
    'Spam or advertising': 'Spam o pubblicità',
    'Copyright infringement': 'Violazione del diritto d’autore',
    'Duplicate content': 'Contenuto duplicato',
    'Off-topic content': 'Contenuto fuori tema',
    'Exposed personal data': 'Dati personali esposti',
    'Content deleted': 'Contenuto eliminato',
    'Failed to delete content': 'Impossibile eliminare il contenuto',
    'Sending...': 'Invio...',
    'New Releases': 'Novità',
    'Top Rated': 'Più Votati',
    'See all': 'Vedi tutto',
    'Browse by category': 'Sfoglia per categoria',
    'No content found': 'Nessun contenuto trovato',
    'Try adjusting your filters': 'Prova a modificare i filtri',
    'Go to slide': 'Vai alla diapositiva',
    'Back to Store': 'Torna al Negozio',
    'Loading board...': 'Caricamento pubblicazione...',
    'No description provided': 'Nessuna descrizione',
    stars: 'stelle',
    votes: 'voti',
    Rate: 'Valuta',
    'Be the first to rate': 'Sii il primo a valutare',
    'In progress': 'In corso',
    'Tablet preview': 'Anteprima tablet',
    'Tablet preview coming soon': 'Anteprima tablet in arrivo',
    Republish: 'Ripubblica',
    Filters: 'Filtri',
    Clear: 'Pulisci',
    Speak: 'Parla',
    Previous: 'Precedente',
    'Previous page': 'Pagina precedente',
    'Next page': 'Pagina successiva',
    'Remove last': 'Rimuovi ultimo',
    Fullscreen: 'Schermo intero',
    'Exit fullscreen': 'Esci da schermo intero',
    'Go to Portal': 'Vai al Portale',
    'Sign in': 'Accedi',
    'Sign out': 'Esci',
    'Open menu': 'Apri menu',
    'Close menu': 'Chiudi menu',
    Menu: 'Menu',
    'Publication not available': 'Questa pubblicazione non è disponibile',
    'All languages': 'Tutte le lingue',
    'Switch to dark mode': 'Passa al tema scuro',
    'Switch to light mode': 'Passa al tema chiaro',
    'Toggle theme': 'Cambia tema',
    'Sign in to download': 'Accedi per scaricare',
    'Sign in to rate': 'Accedi per valutare',
    'Author not found': 'Autore non trovato',
    'Unnamed author': 'Autore senza nome',
    publication: 'pubblicazione',
    publications: 'pubblicazioni',
    'Boards by this author': 'Tavole di questo autore',
    'Link copied to clipboard': 'Link copiato negli appunti',
    'Failed to download content': 'Download non riuscito',
    'Download started': 'Download avviato',
    'Thanks for your vote!': 'Grazie per il tuo voto!',
    'Failed to send vote': 'Errore nell’invio del voto',
    'Content promoted': 'Contenuto in evidenza',
    'View profile': 'Vedi profilo',
    'Page Size': 'Dimensione Pagina',
    'Licenses Search': 'Cerca Licenze',
    Licenses: 'Licenze',
    'Stripe Information': 'Informazioni di Stripe',
    'No information': 'Nessuna informazione',
    Canceled: 'Cancellato',
    past_due: 'Pagamento scaduto',
    active: 'Attivo',
    'Support Areas': 'Aree di Supporto',
    Customers: 'Clienti',
    'Livox Users': 'Utenti Livox',
    'Distributor Totals': 'Statistiche del Distributore',
    'Portal Administration': 'Amministrazione del Portale',
    'My Devices': 'I miei Dispositivi',
    'My Livox Users': 'I miei Utenti Livox',
    'My Licenses': 'Le mie Licenze',
    'My Authorized Users': 'Utenti Autorizzati',
    'New Customer': 'Nuovo Cliente',
    'Notify Customer': 'Notifica Cliente',
    'New Branch': 'Nuova Sede',
    'New Portal User': 'Nuovo Utente del Portale',
    'Install Key': 'Chiave di Installazione',
    'License Key': 'Chiave di Licenza',
    'New License': 'Nuova Licenza',
    'New Registration Link': 'Crea Link di Registrazione',
    'All Livox users': 'Tutti gli Utenti Livox',
    Home: 'Home',
    Customer: 'Cliente',
    'My Branches': 'Le mie Sedi',
    Branches: 'Sedi',
    'Last Name': 'Cognome',
    Gender: 'Genere',
    Age: 'Età',
    Evaluations: 'Valutazioni',
    'Last Evalution': 'Ultima Valutazione',
    License: 'Licenza',
    Key: 'Chiave',
    Status: 'Stato',
    City: 'Città',
    State: 'Stato',
    Country: 'Paese',
    Available: 'Disponibile',
    Active: 'Attivo',
    Inactive: 'Inattivo',
    Phone: 'Telefono',
    'First Name': 'Nome',
    'Device Name': 'Nome Dispositivo',
    Version: 'Versione',
    'Remove Device': 'Rimuovi Dispositivo',
    User: 'Utente',
    Contact: 'Contatto',
    Diagnosis: 'Diagnosi',
    Device: 'Dispositivo',
    'Delete User': 'Elimina Utente',
    'My Users': 'Utente Livox',
    Expire: 'Data di Scadenza',
    Support: 'Supporto',
    Dates: 'Date',
    'Expiration Date': 'Data di Scadenza',
    'Support Date': 'Data di Supporto',
    'Click to edit expiration date':
      'Fare clic per modificare la data di scadenza',
    'Click to edit support date':
      'Fare clic per modificare la data di supporto',
    'Expiration date updated successfully':
      'Data di scadenza aggiornata con successo',
    'Support date updated successfully':
      'Data di supporto aggiornata con successo',
    'Failed to update expire date':
      'Impossibile aggiornare la data di scadenza',
    'Failed to update support date':
      'Impossibile aggiornare la data di supporto',
    'MAC Address': 'Indirizzo MAC',
    'Device Version': 'Versione del Dispositivo',
    Name: 'Nome',
    'Num. Licenses': 'Num. Licenze',
    Activated: 'Attivato',
    Inactivated: 'Disattivato',
    Email: 'Email',
    'My Auth Users': 'I miei Utenti Autorizzati',
    Holder: 'Titolare',
    'Customer Licenses': 'Licenze del Cliente',
    Type: 'Tipo',
    Distribution: 'Distributore',
    Language: 'Lingua',
    Reseller: 'Rivenditore',
    Text: 'Testo',
    'Number of Devices': 'Numero di Dispositivi',
    'Lifetime License': 'Licenza a Vita',
    Address: 'Indirizzo',
    Zipcode: 'CAP',
    Neighborhood: 'Quartiere',
    'Contact Email': 'Email di Contatto',
    'Confirm Contact Email': 'Conferma Email di Contatto',
    'First name': 'Nome',
    'Last name': 'Cognome',
    Group: 'Gruppo',
    Password: 'Password',
    Male: 'Maschio',
    Female: 'Femmina',
    'My Portal Users': 'I miei Utenti del Portale',
    'Edit Profile': 'Modifica Profilo',
    'Change Password': 'Cambia Password',
    Register: 'Registrati',
    'I forgot my password': 'Ho dimenticato la password',
    Account: 'Conto',
    'No results': 'Nessun risultato',
    'Customers Search': 'Ricerca Clienti',
    Search: 'Cerca',
    'Search by name or email': 'Cerca per nome o email',
    'Tree view': 'Vista ad albero',
    'Table view': 'Vista tabella',
    Download: 'Scarica',
    'Registration Link': 'Link di Registrazione',
    Page: 'Pagina',
    of: 'di',
    results: 'risultati',
    'View Branches': 'Visualizza Sedi',
    'View Users': 'Visualizza Utenti',
    Cancel: 'Annulla',
    Create: 'Crea',
    'Branch Name': 'Nome della Sede',
    'Confirm Password': 'Conferma Password',
    'Customer Branches': 'Sedi del Cliente',
    'My Evaluations': 'Le mie Valutazioni',
    'Livox User': 'Utente Livox',
    'Add Branch': 'Aggiungi Sede',
    'Distributor Customers': 'Clienti del Distributore',
    'New Support Area': 'Nuova area di supporto',
    'Assign Users': 'Assegna Utenti',
    'Assign Customers': 'Assegna Clienti',
    Dashboard: 'Dashboard',
    'Unique users by day': 'Utenti unici al giorno',
    'Users by language': 'Utenti per lingua',
    'Users by country': 'Utenti per paese',
    Devices: 'Dispositivi',
    'Manage my devices': 'Gestisci i miei dispositivi',
    News: 'Novità',
    'Read more': 'Leggi di più',
    'Total Licenses': 'Licenze Totali',
    'Paid Licenses': 'Licenze Pagate',
    'Free Licenses': 'Licenze Gratuite',
    'Distributor Stats': 'Statistiche del Distributore',
    Users: 'Utenti',
    Remove: 'Rimuovi',
    Evaluate: 'Valuta',
    'Cognitive Evaluation': 'Valutazione Cognitiva',
    'Recognizes images': 'Riconosce immagini',
    'Notion of cause and effect': 'Nozione di causa ed effetto',
    'Has notion of body awareness': 'Ha nozione del proprio corpo',
    'Has symbolic representation': 'Ha rappresentazione simbolica',
    'Makes choices': 'Prende decisioni',
    Literate: 'Alfabetizzato',
    'Auditory Agnosia': 'Agnosia Uditiva',
    'Cow mooing': 'Mucca muggita',
    'Chicken clucking': 'Gallina chioccia',
    'Dog barking': 'Cane abbaia',
    Doorbell: 'Campanello',
    Sirens: 'Sirene',
    'Visual Agnosia': 'Agnosia Visiva',
    Dog: 'Cane',
    Cat: 'Gatto',
    Bird: 'Uccello',
    House: 'Casa',
    Banana: 'Banana',
    Grapes: 'Uva',
    Pineapple: 'Ananas',
    Watermelon: 'Anguria',
    Telephone: 'Telefono',
    Car: 'Macchina',
    Shoe: 'Scarpa',
    Ball: 'Palla',
    'Visual Oral Language': 'Linguaggio Orale Visivo',
    'Where is the ball?': "Dov'è la palla?",
    'Where is the doll?': "Dov'è la bambola?",
    'Are you at home?': 'Sei a casa?',
    'What is the name of your mother?': 'Qual è il nome di tua madre?',
    'What is your name?': 'Qual è il tuo nome?',
    'Does he/she know his/her birthday?': 'Conosce la data del suo compleanno?',
    'Does he/she know his/her name?': 'Conosce il suo nome?',
    'Does he/she orient to date/time?': 'È orientato a data/ora?',
    'Can he/she follow one step directions?':
      'Può seguire istruzioni semplici?',
    'Can he/she follow two step directions?':
      'Può seguire istruzioni complesse?',
    'Behavior Evaluation': 'Valutazione Comportamentale',
    'Does he/she bite?': 'Morde?',
    'Does he/she hit his/her head on the wall?':
      'Si colpisce la testa contro il muro?',
    'Does he/she understand feelings?': 'Comprende i sentimenti?',
    'Does he/she sleep well?': 'Dorme bene?',
    General: 'Generale',
    'Does he/she cry?': 'Piange?',
    'Does he/she have temper tantrums?': "Ha scatti d'ira?",
    'Is he/she aggressive?': 'È aggressivo?',
    'Does he/she eat well?': 'Mangia bene?',
    'Does he/she run from one place to another?':
      "Corre da un posto all'altro?",
    'Does he/she focus in an activity?': "Si concentra su un'attività?",
    'Does he/she play with other children?': 'Gioca con altri bambini?',
    'Does he/she have a hard time to sleep?': 'Ha difficoltà a dormire?',
    'Does he/she like to be alone?': 'Gli piace stare solo?',
    'Does he/she demonstrate joint attention?':
      'Dimostra attenzione condivisa?',
    'Does he/she scream?': 'Urla?',
    'Is he/she hypersensitive to sensory stimuli?':
      'È ipersensibile agli stimoli sensoriali?',
    'Is he/she unaware to sensory stimuli?':
      'È insensibile agli stimoli sensoriali?',
    Holders: 'Titolari',
    Purcharse: 'Acquista',
    Edit: 'Modifica',
    Delete: 'Elimina',
    'E-mail': 'E-mail',
    'Full Name': 'Nome Completo',
    'Phone Number': 'Numero di Telefono',
    Save: 'Salva',
    Undo: 'Annulla',
    Publish: 'Pubblica',
    'New Item': 'Nuovo Elemento',
    Attributes: 'Attributi',
    'Display Text': 'Testo da Visualizzare',
    'Spoken Phrase': 'Frase da Pronunciare',
    'Expand image on click': 'Espandi immagine al click',
    Colors: 'Colori',
    Pictures: 'Immagini',
    'Search a symbol': 'Cerca un simbolo',
    'Field Changed': 'Campo Modificato',
    'Old Value': 'Valore Vecchio',
    'New Value': 'Valore Nuovo',
    'License History': 'Cronologia della Licenza',
    Branch: 'Sede',
    'Evaluation Date': 'Data di Valutazione',
    'Branch Licenses': 'Licenze della Sede',
    'Add Licenses to Branch': 'Aggiungi licenze alla Sede',
    Confirm: 'Conferma',
    Close: 'Chiudi',
    'Livox version distribution': 'Distribuzione per versione di Livox',
    'Expires in': 'Scade in',
    'Support ends': 'Il supporto termina il',
    available: 'disponibile',
    'Android OS distribution': 'Distribuzione per versione di Android',
    likes: 'mi piace',
    downloads: 'download',
    'Reviewed at': 'Rivisto il',
    Comment: 'Commenta',
    Pending: 'In Attesa',
    Approved: 'Approvato',
    Archived: 'Archiviato',
    Accept: 'Accetta',
    Reject: 'Rifiuta',
    Reason: 'Motivo',
    Rejected: 'Rifiutato',
    'Create License Registration Link':
      'Crea link di registrazione della licenza',
    'Create separate install keys': 'Crea chiavi di installazione separate',
    'Log Out': 'Disconnettiti',
    'Evaluate Livox User': "Valuta l'utente Livox",
    Billing: 'Fatturazione',
    'Acquire Livox': 'Acquista Livox',
    'You are about to purchase the best alternative comunication app in the world!':
      'Stai per acquistare la migliore app di comunicazione alternativa al mondo!',
    '1. Select a Plan': '1. Seleziona un Piano',
    BASIC: 'BASIC',
    'Up to 3 users': 'Fino a 3 utenti',
    'Smart Scan': 'Scansione Intelligente',
    'IntelliTouch - Touch Correction': 'IntelliTouch - Correzione del Tocco',
    'Virtual keyboard': 'Tastiera Virtuale',
    'Stock Images (20,000 images)': "Immagini d'archivio (+20.000 immagini)",
    'Creation of pedagogical content': 'Creazione di contenuti pedagogici',
    'Voice, text and image customization':
      'Personalizzazione di voce, testo e immagine',
    'Content transfer between tablets': 'Trasferimento contenuti tra tablet',
    '/ month': 'al mese',
    'on a yearly plan': 'nel piano annuale',
    PLUS: 'PLUS',
    'Recommended for families': 'Raccomandato per le famiglie',
    'New Features Update': 'Aggiornamento di nuove funzionalità',
    'Trigger Control': 'Controllo con Trigger',
    'Livox control with the blink of an eye':
      'Controllo con un battito di ciglia',
    'Artificially Intelligent Item Recommendations Based on Time and Location':
      'Raccomandazioni Intelligenti Articoli in base a orario e posizione',
    PRO: 'PRO',
    'Recommended for professionals!': 'Raccomandato per i professionisti!',
    'UNLIMITED Users': 'Utenti ILLIMITATI',
    'Complete assessment and content tool to track users progress with Livox (patients or students)':
      'Valutazione completa e strumento di contenuti per monitorare il progresso degli utenti con Livox (pazienti o studenti)',
    '2. Select a payment plan': '2. Seleziona il piano di pagamento',
    monthly: 'mensile',
    quarterly: 'trimestrale',
    '% off': '% di sconto',
    yearly: 'annuale',
    '3. Confirm the value': '3. Conferma il valore',
    'per month': 'al mese',
    'Proceed with the checkout': 'Procedi al pagamento',
    'Select a Plan': 'Seleziona un Piano',
    Continue: 'Continua',
    'Get Livox': 'Acquista Livox',
    'Select a Plan - Livox Portal': 'Scegli un Piano - Livox',
    '1. Confirm your Plan': '1. Conferma il tuo Piano',
    '3. Confirm the plan': '3. Conferma il piano',
    Checkout: 'Pagamento',
    'Secure checkout': 'Pagamento Sicuro',
    'per year': "all'anno",
    Change: 'Cambia',
    'per quarter': 'a trimestre',
    'Cardholder Name': 'Nome del Titolare',
    'Street address': 'Indirizzo',
    'Apartment / Suite / Unit / Building':
      'Appartamento / Suite / Unità / Edificio',
    'Billing Address': 'Indirizzo di Fatturazione',
    'Payment Info': 'Informazioni di Pagamento',
    'Credit or debit card': 'Carta di credito o debito',
    'Credit card info secured by': 'Informazioni sulla carta protette da',
    Success: 'Successo',
    'Upload from .zip file here': 'Carica file .zip qui',
    'Published Title': 'Titolo Pubblicato',
    'Publish Content': 'Pubblica Contenuto',
    'Cover Image': 'Immagine di Copertina',
    'Upload Image': 'Carica Immagine',
    Buy: 'Compra',
    Boards: 'Tabelloni',
    'Thanks for purcharsing Livox': 'Grazie per aver acquistato Livox',
    'We are processing your payment, a receipt will be sent to':
      'Stiamo elaborando il tuo pagamento, una ricevuta verrà inviata a',
    'with instructions on how activate Livox.':
      'con istruzioni su come attivare Livox.',
    'If you have any question / issues': 'Per qualsiasi domanda / problema',
    'contact our support.': 'contatta il nostro supporto.',
    Deleted: 'Eliminato',
    'You have successfully submitted this board for reviewing, please wait up to 48 hours to be approved.':
      "Hai inviato con successo questo tabellone per la revisione, attendi fino a 48 ore per l'approvazione.",
    'You have successfully registered, Please return to the tablet to proceed.':
      'Ti sei registrato con successo, per favore torna al tablet per continuare.',
    'Validation notEmpty on coverImage failed':
      "Per favore aggiungi un'immagine alla tua pubblicazione",
    'You are not logged in. Create your account to see more of this content':
      "Non hai effettuato l'accesso. Crea il tuo account per vedere più di questo contenuto.",
    'Buy Livox': 'Acquista Livox',
    'Select your plan and payment method to get started.':
      'Seleziona il tuo piano e metodo di pagamento per iniziare.',
    'payment.pageDescription':
      "Seleziona il tuo piano e il metodo di pagamento per completare l'acquisto.",
    'payment.propaganda':
      'Stai per acquistare la migliore app di comunicazione alternativa al mondo!',
    'payment.activeSubscriptionsCount': '{{count}} abbonamento/i attivo/i',
    'payment.youHaveLicenses': 'Hai licenze attive.',
    'payment.viewLicensesHere': 'Visualizza le tue licenze qui',
    'payment.youHaveActiveSubscriptions': 'Hai abbonamenti attivi.',
    'payment.viewMyAssessments': 'Visualizza in Le mie valutazioni',
    'payment.viewMySubscriptions': 'Visualizza in I miei abbonamenti',
    'payment.onlyPortugueseTitle': 'Pagamento non disponibile',
    'payment.onlyPortugueseAvailable':
      'Il pagamento è disponibile solo in portoghese al momento.',
    'payment.blockedInBrazilTitle':
      'Pagamento non disponibile nella tua regione',
    'payment.blockedInBrazil':
      'Il pagamento online non è disponibile per gli accessi dal Brasile.',
    'payment.blockedContactTitle': 'Contattaci:',
    'payment.blockedContactBrazil':
      'Brasile\n+55 81 97108 3009 (Telefono e WhatsApp)\ncontato@livox.com.br\nAvenida Fagundes Varela, 950, LJ 15, CXP 1776, Jardim Atlântico, Olinda-Pe, Brasile, CEP: 53140-080',
    'payment.blockedContactUS':
      'Stati Uniti\n+1 (407) 449-6391\ncarlos@livox.com.br\nGrand National Drive, suite 128, Orlando, FL',
    'payment.blockedContactJordan':
      'Giordania\n00962796870058\nala.alramahi@gmail.com',
    'payment.noLicensesEncourage':
      'Non hai licenze. Acquista ora per iniziare con Livox!',
    Media: 'Media',
    'Upload an image or video': "Carica un'immagine o video",
    'No image': 'Nessuna Immagine',
    'Welcome to your boards page': 'Benvenuto alla tua pagina dei tabelloni',
    'Assistive Tecnology': 'Tecnologia Assistiva',
    '1. Create': '1. Crea',
    'To get started use the Livox Studio to create cards, upload images, music and videos':
      'Per iniziare, usa Livox Studio per creare schede, caricare immagini, musica e video',
    '2. Publish': '2. Pubblica',
    'Submit you content to be published in the store':
      'Invia il tuo contenuto per essere pubblicato nel negozio',
    '3. Get feedback': '3. Ricevi Feedback',
    'Receive feedback and satisfaction on seeing your content being used all around the globe!':
      'Ricevi feedback e soddisfazione vedendo il tuo contenuto utilizzato in tutto il mondo!',
    'Livox Portal': 'Portale Livox',
    'A content store made for you!': 'Un negozio di contenuti creato per te!',
    'The best portal of assistive technologies in the world!':
      'Il miglior portale di tecnologie assistive del mondo!',
    'Learn More': 'Scopri di Più',
    'Recent Items': 'Elementi Recenti',
    by: 'da',
    'Untitled Content': 'Contenuto Senza Titolo',
    'Loading...': 'Caricamento...',
    'Click here to add a title': 'Clicca qui per aggiungere un titolo',
    'Portuguese (BR)': 'Portoghese (Brasile)',
    English: 'Inglese',
    Arabic: 'Arabo',
    German: 'Tedesco',
    'No boards found': 'Nessun tabellone trovato',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this device?':
      "Rimuovere questo dispositivo farà disconnetterà l'utente dall'app. Sei sicuro di voler rimuovere questo dispositivo?",
    'New User': 'Nuovo Utente',
    'Login as another user': 'Accedi come un altro utente',
    Technical: 'Tecnico',
    Pedagogical: 'Pedagogico',
    Results: 'Risultati',
    'Top Rated Items': 'Elementi Popolari',
    'Back to Livox Portal': 'Torna al Portale Livox',
    'No Categories': 'Nessuna Categoria',
    Author: 'Autore',
    'No votes yet': 'Ancora nessun voto',
    'Rate this content': 'Valuta questo contenuto',
    'You must be logged in to vote on this content!':
      'Devi essere connesso per votare questo contenuto!',
    'Go to Livox Store': 'Vai al Negozio Livox',
    'Go to Play Store': 'Vai al Play Store',
    'Sign Up': 'Iscriviti',
    Login: 'Accedi',
    'Log In': 'Accedi',
    'License Availability': 'Disponibilità Licenze',
    'My Profile': 'Il mio Profilo',
    'No description available': 'Nessuna descrizione disponibile',
    Publications: 'Pubblicazioni',
    'User Profile': 'Profilo Utente',
    'New user': 'Nuovo utente',
    'Livox Users Growth': 'Crescita Utenti di Livox',
    'Users Disability Distribution': 'Distribuzione Utenti per Disabilità',
    'Users Disabilty Distribution': 'Distribuzione Utenti per Disabilità',
    'Contact us': 'Contattaci',
    'Support Type': 'Tipo di Supporto',
    Subject: 'Oggetto',
    Message: 'Messaggio',
    Send: 'Invia',
    'License Distribution': 'Distribuzione Licenze',
    'Manage my licenses': 'Gestisci le mie licenze',
    'Show From': 'Mostra da',
    'Only my branch': 'Solo la mia Sede',
    'All Branches': 'Tutte le Sedi',
    'Last Validation Date': 'Ultima Data di Validazione',
    'Device ID': 'ID Dispositivo',
    'About you': 'Su di te',
    'No publications yet': 'Nessuna pubblicazione ancora',
    'No description available.': 'Nessuna descrizione disponibile.',
    'Remove this livox user? ': 'Rimuovere questo utente Livox?',
    'Users by city': 'Utenti per città',
    'Create new customer': 'Crea nuovo cliente',
    'Boards Search': 'Cerca tabelloni',
    'Add a branch to': 'Aggiungi una sede a',
    'Edit Branch': 'Modifica Sede',
    'Edit Customer': 'Modifica Cliente',
    Update: 'Aggiorna',
    'Delete Branch': 'Elimina Sede',
    'Create Branch Administrator': 'Crea Amministratore di Sede',
    'Deleting this branch will remove the users and all licenses from it. Are you sure you want to delete this branch?':
      'Eliminare questa sede rimuoverà gli utenti e tutte le licenze ad essa associate. Sei sicuro di voler eliminare questa sede?',
    'Deleting this branch will transfer all users and licenses from this branch and its child branches to the parent branch.':
      'Eliminare questa sede trasferirà tutti gli utenti e le licenze di questa sede e delle sue sedi figlie alla sede padre.',
    'Deleting the root branch will remove users, licenses, Livox users and holders of this customer and all its branches.':
      'Eliminare la sede radice rimuoverà utenti, licenze, utenti Livox e titolari di questo cliente e di tutte le sue sedi.',
    'Are you sure you want to delete this branch?':
      'Sei sicuro di voler eliminare questa sede?',
    'Are you sure you want to delete branch':
      'Sei sicuro di voler eliminare la sede',
    'Delete all users of this customer and all its branches.':
      'Eliminare tutti gli utenti di questo cliente e di tutte le sue sedi.',
    'Delete all licenses of this customer and all its branches.':
      'Eliminare tutte le licenze di questo cliente e di tutte le sue sedi.',
    'Delete all Livox users of this customer and all its branches.':
      'Eliminare tutti gli utenti Livox di questo cliente e di tutte le sue sedi.',
    'Delete all holders of this customer and all its branches.':
      'Eliminare tutti i titolari di questo cliente e di tutte le sue sedi.',
    'Transfer all users from this branch and its child branches to the parent branch.':
      'Trasferire tutti gli utenti di questa sede e delle sue sedi figlie alla sede padre.',
    'Transfer all licenses from this branch and its child branches to the parent branch.':
      'Trasferire tutte le licenze di questa sede e delle sue sedi figlie alla sede padre.',
    'Remove this branch and its child branch structure.':
      'Rimuovere questa sede e la struttura delle sue sedi figlie.',
    'Reset Password': 'Reimposta Password',
    'years ago': 'anni fa',
    'months ago': 'mesi fa',
    'days ago': 'giorni fa',
    'hours ago': 'ore fa',
    'minutes ago': 'minuti fa',
    'seconds ago': 'secondi fa',
    'Livox app is outdated on this device':
      "L'app Livox è obsoleta su questo dispositivo",
    'Sort By...': 'Ordina Per...',
    'Device Android Id': 'ID Android del Dispositivo',
    Saved: 'Salvato',
    'Saving...': 'Salvataggio in corso...',
    'Error! Please refresh the page.': 'Errore! Per favore aggiorna la pagina.',
    Review: 'Revisione',
    'Upload an audio or video': "Carica un'audio o video",
    'All Languages': 'Tutte le lingue',
    Portuguese: 'Portoghese (Brasile)',
    "By clicking 'Publish' you are agreeing that you have read and accepted our":
      'Cliccando su "Pubblica" accetti di aver letto e accettato i nostri',
    'terms of use': 'termini di uso',
    'Add a shortcut...': "Aggiungi un'scorciatoia...",
    ExampleShortcut:
      'Per esempio: "Cosa vuoi mangiare?" per un tabellone di cibo.',
    'Create voice commands to open this board on Livox app!':
      "Crea comandi vocali per aprire questo tabellone sull'app Livox!",
    Shortcuts: 'Scorciatoie',
    'NEW!': 'NUOVO!',
    NEW: 'NUOVO',
    'Uploading...': 'Caricamento in corso...',
    'Processing files...':
      'Elaborazione dei file in corso... Attendere il completamento.',
    'The file you uploaded is too large.':
      'Il file che hai caricato è troppo grande.',
    'Error: File too large': 'Errore: Il file è troppo grande',
    'Error: Sorry we just encountered an unexpected error, please try again':
      'Errore: Ci scusiamo, si è verificato un errore imprevisto. Per favore, riprova.',
    'Error: The zip file appears to be corrupted or is not a Livox content':
      'Errore: Il file zip sembra essere corrotto o non è un contenuto Livox',
    'Are you sure you want to delete this content?':
      'Sei sicuro di voler eliminare questo contenuto?',
    'Error: Invalid content, please make sure that the file being uploaded is a .zip file':
      'Errore: Contenuto non valido, assicurati che il file caricato sia un file .zip',
    'Get Started': 'Inizia',
    'Record a new shortcut via voice':
      'Registra una nuova scorciatoia utilizzando la voce',
    'You have blocked this website of using the Microphone.':
      "Hai bloccato questo sito dall'utilizzare il microfono",
    "Couldn't detect speech, please check your microphone settings.":
      'Impossibile rilevare la voce, controlla le impostazioni del tuo microfono.',
    'Your browser is not compatible with the Speech Recognition API, but you can manually enter the shortcuts below':
      "Il tuo browser non è compatibile con l'API di riconoscimento vocale, ma puoi inserire manualmente le scorciatoie qui sotto.",
    'Error while recording shortcut, please try again':
      'Errore durante la registrazione della scorciatoia, riprova per favore.',
    Features: 'Caratteristiche',
    'Voice Shortcuts': 'Scorciatoie Vocali',
    'Add shortcuts to this folder': 'Aggiungi scorciatoie a questa cartella',
    shortcuts: 'scorciatoie',
    'You have pending reviews': 'Hai revisioni pendenti',
    'No pending reviews': 'Nessuna revisione pendente',
    'Admin Portal': 'Portale Amministratore',
    'Log out': 'Esci',
    'Zip Overwrite': 'Sovrascrivi con Zip',
    Share: 'Condividi',
    'Used Licenses': 'Licenze Utilizzate',
    'Last Registered Activity': 'Ultima Attività Registrata',
    'Interactions by time of day': 'Interazioni per ora del giorno',
    'Avg. Interactions / User': 'Media Interazioni / Utente',
    Featured: 'In primo piano',
    'Promoted Content': 'Contenuti Promossi',
    'Rate this': 'Valuta questo',
    Promote: 'Promuovi',
    'Your rating': 'La tua valutazione',
    Play: 'Riproduci',
    'Back to Edit': 'Torna a Modificare',
    Next: 'Successivo',
    'Inside items': 'Elementi Interni',
    Regular: 'Regolare',
    'Book Mode': 'Modalità Libro',
    Fixed: 'Fisso',
    System: 'Sistema',
    Rows: 'Righe',
    Collumns: 'Colonne',
    Display: 'Visualizzazione',
    'Page Mode': 'Modalità Pagina',
    'Text Size': 'Dimensione Testo',
    Print: 'Stampa',
    'This dashboard is made with aggregated data across all licenses':
      'Questa dashboard è realizzata con dati aggregati su tutte le licenze',
    ' assigned to your user': ' assegnate al tuo utente',
    'view licenses': 'visualizza licenze',
    'No Data': 'Nessun Dato',
    'Last 30 days': 'Ultimi 30 giorni',
    'Last 6 months': 'Ultimi 6 mesi',
    'Last year': 'Ultimo anno',
    'Results for': 'Risultati per',
    'Full Screen': 'Schermo Intero',
    'Cards cut — navigate and paste into empty slots':
      'Schede tagliate — naviga e incolla negli spazi vuoti',
    'No empty slots to paste into': 'Nessuno spazio vuoto per incollare',
    'Cards pasted': 'Schede incollate',
    'cards still to paste': 'schede ancora da incollare',
    'ready to paste': 'pronto per incollare',
    'Paste actions': 'Azioni di incolla',
    'Cards grouped into folder': 'Schede raggruppate in una cartella',
    'Select at least 2 cards to group':
      'Seleziona almeno 2 schede per raggruppare',
    'New folder': 'Nuova cartella',
    Cut: 'Taglia',
    Copy: 'Copia',
    Paste: 'Incolla',
    'Paste Inside': 'Incolla Dentro',
    Dark: 'Modalità Scura',
    Light: 'Modalità Chiara',
    'Card Properties': 'Proprietà della Scheda',
    'Export PDF': 'Esporta PDF',
    'Export as PDF': 'Esporta come PDF',
    'Export section layout': 'Layout',
    'Export section content': 'Contenuto',
    'Standard layout (grid)': 'Layout standard (griglia)',
    'Single card (1×1 full page)': 'Scheda singola (1×1 pagina intera)',
    'Select card to export': 'Seleziona la scheda da esportare',
    'Select a card': 'Seleziona una scheda',
    'Current board (grid)': 'Scheda attuale (griglia)',
    'Fixed bar only': 'Solo barra fissa',
    'Board + Fixed bar': 'Scheda + Barra fissa',
    'Main Board': 'Scheda Principale',
    Part: 'Parte',
    'Cut here': 'Taglia qui',
    'Exported on': 'Esportato il',
    'Fixed Bar': 'Barra Fissa',
    'Cut for continuous use': 'Taglia per uso continuo',
    'Audio / Video': 'Audio / Video',
    'Add an audio or video': 'Aggiungi un audio o video',
    'Uploaded image': 'Immagine caricata',
    'On touching this board show this image, if none set it will skip the action':
      "Toccando questo tabellone, mostra questa immagine, se non impostata verrà saltata l'azione",
    'Search an image': "Cerca un'immagine",
    Suggestions: 'Suggerimenti',
    Images: 'Immagini',
    Publication: 'Pubblicazione',
    'Manage Boards': 'Gestisci Tabelloni',
    'Livox Web': 'Livox Web',
    'Settings - Display': 'Impostazioni - Visualizzazione',
    Start: 'Avvia',
    Settings: 'Impostazioni',
    'Manage Users': 'Gestisci Utenti',
    Voice: 'Voce',
    Controls: 'Controlli',
    'Artificial Intelligence': 'Intelligenza Artificiale',
    About: 'Informazioni',
    Test: 'Prova',
    'Voice Language': 'Lingua della Voce',
    'Voice Actor': 'Attore della Voce',
    'Voice speed': 'Velocità della Voce',
    'Pitch Rate': 'Tono della Voce',
    Preview: 'Anteprima',
    'Quick chat': 'Chat Veloce',
    'Font Size': 'Dimensione Carattere',
    'Paging Mode': 'Modalità Paginazione',
    'Touch correction': 'Correzione del tocco',
    'Time to wait between touches': 'Tempo di attesa tra i tocchi',
    'Manually set time to prevent any further touches. Set zero seconds to disable.':
      'Imposta manualmente il tempo per prevenire ulteriori tocchi. Imposta a zero secondi per disabilitare.',
    'Natural Conversation': 'Conversazione Naturale',
    'Trigger words': 'Parole Chiave',
    'Registered keywords that Livox will listen before issuing an action. Keywords are case insensitive.':
      "Parole chiave registrate che Livox ascolterà prima di eseguire un'azione. Le parole chiave non distinguono tra maiuscole e minuscole.",
    'No keywords created': 'Nessuna parola chiave creata',
    'Speak navigation arrows': 'Pronuncia le frecce di navigazione',
    'Enable natural conversation': 'Abilita la Conversazione Naturale',
    'Remote voice commands that can show appropriate boards depending on context. Requires a microphone and internet connection.':
      'Comandi vocali remoti che possono mostrare tabelloni appropriati a seconda del contesto. Richiede un microfono e una connessione internet.',
    'Enable Intellitouch': 'Abilita Intellitouch',
    'Recommended for users with motor disabilities. Automatically detects imperfect touches.':
      'Raccomandato per utenti con disabilità motorie. Rileva automaticamente tocchi imperfetti.',
    'Delay will be set dynamically by Intellitouch.':
      'Il tempo di ritardo verrà impostato dinamicamente da Intellitouch.',
    Legacy: 'Legacy',
    'Livox5+': 'Livox 5.0+',
    'Licenses Status': 'Stato delle Licenze',
    'Activity days': 'Giorni di Attività',
    'Active Usage Status': 'Stato di Utilizzo Attivo',
    'Above Average': 'Sopra la Media',
    'Below Average': 'Sotto la Media',
    'Average Interactions': 'Media di Interazioni: {{clicks}} clic.',
    'Inactive licenses are those in which no user has used Livox in the given period.':
      'Le licenze inattive sono quelle in cui nessun utente ha utilizzato Livox nel periodo dato.',
    'Version Status': 'Stato della Versione',
    'Devices with older Operating System (OS) versions are at risk of losing access to Livox.':
      "I dispositivi con versioni del Sistema Operativo (OS) più vecchie rischiano di perdere l'accesso a Livox.",
    'Outdated OS': 'OS Obsoleto',
    'Outdated Livox': 'Livox Obsoleto',
    'Operational System Version': 'Versione del Sistema Operativo',
    'Device usage (%)': 'Utilizzo del dispositivo (%)',
    'Device usage': 'Utilizzo del dispositivo',
    'Disability distribution': 'Distribuzione per Disabilità',
    Period: 'Periodo',
    '30 days': '30 giorni',
    '45 days': '45 giorni',
    '2 months': '2 mesi',
    '6 months': '6 mesi',
    '1 year': '1 anno',
    'Global Active Usage': 'Utilizzo Attivo Globale',
    'Percent of the users that used above and below global average ({{clicks}} clicks).':
      'Percentuale degli utenti che hanno utilizzato sopra e sotto la media globale ({{clicks}} clic).',
    'Most Active': 'Più Attivo',
    'Least Active': 'Meno Attivo',
    'The users that used 30% above and below than your average (> {{upper_limit}} and < {{lower_limit}} respectively).':
      'Gli utenti che hanno utilizzato il 30% sopra e sotto la tua media (> {{upper_limit}} e < {{lower_limit}} rispettivamente).',
    'Active users are those that had at least 1 interaction on the time period.':
      'Gli utenti attivi sono quelli che hanno avuto almeno 1 interazione nel periodo di tempo.',
    'Activity ({{days}} days)': 'Attività ({{days}} giorni)',
    'Dashboard Charts': 'Grafici del Cruscotto',
    'Users per disability': 'Utenti per disabilità',
    'Users per age': 'Utenti per età',
    Autism: 'Autismo',
    'Amyotrophic Lateral Sclerosis': 'Sclerosi Laterale Amiotrofica',
    'Cerebral Palsy': 'Paralisi Cerebrale',
    'Person without disabilities': 'Persona senza disabilità',
    'No physical disabilities, just unable to speak':
      'Nessuna disabilità fisica, solo incapacità di parlare',
    'Stroke Sequelae': 'Sequele di Ictus',
    'Down Syndrome': 'Sindrome di Down',
    'Brain Injury': 'Lesione Cerebrale',
    'Another motor impairment': 'Altra disabilità motoria',
    'Another cognitive impairment': 'Altra disabilità cognitiva',
    'Store Statistics': 'Statistiche del Negozio',
    Creators: 'Creatori',
    Published: 'Pubblicati',
    'Unique Downloads': 'Download Unici',
    Items: 'Elementi',
    'SymbolStyx usage': 'Uso di SymbolStix',
    'Uploaded Images': 'Immagini Caricate',
    'Uploaded Audio/Video': 'Audio/Video Caricati',
    'Multiple images': 'Immagini Multiple',
    'Most used symbols': 'Simboli più usati',
    'Usage Status': 'Stato di Utilizzo',
    Disclaimer: 'Avviso',
    'basic plan disclaimer':
      "La licenza BASIC è una versione più semplice di Livox, con <b>meno funzionalità</b> e <b>senza supporto tecnico</b>. Normalmente acquistata da genitori che conoscono bene Livox e, per esempio, desiderano un secondo dispositivo con meno risorse da utilizzare all'aperto. <br/> Questa versione non è consigliata a chi sta iniziando a usare Livox, ma è raccomandata per chi ha già una versione PLUS e desidera la BASIC per un secondo dispositivo.",
    'Available Licenses': 'Licenze Disponibili',
    'Unable to log in with provided credentials.':
      'Impossibile accedere con le credenziali fornite. Email e/o password errati.',
    'Renew Licenses': 'Rinnova Licenze',
    Border: 'Bordo',
    'It is not possible to access cards with more than one state':
      'Non è possibile accedere alle carte con più di uno stato',
    'New state': 'Nuovo stato',
    'Only text': 'Solo testo',
    'Livox IntelliBar (Beta)': 'IntelliBar di Livox (Beta)',
    'Print navigation card': 'Stampa le carte di navigazione',
    'Board + IntelliBar': 'Tavola + IntelliBar',
    'AI Error': 'Errore AI:',
    'Create items using AI!': "Crea elementi utilizzando l'IA!",
    'Get cards recommendations for every situation!':
      'Ricevi raccomandazioni di carte per ogni situazione!',
    'Examples:': 'Esempi:',
    'Breakfast items': 'Elementi per la colazione',
    'Teeth brushing steps': 'Passaggi per lavarsi i denti',
    'Quiz option choices': 'Scelte opzioni quiz',
    'and many more!': 'e molti altri!',
    'Cards suggestion with AI': 'Suggerimento di carte con IA',
    '{{used}} of {{limit}} used': '{{used}} di {{limit}} utilizzati',
    'Insufficient JandaIA coins': 'Saldo JandaIA Coins insufficiente',
    'Type a topic': 'Digita un argomento',
    'Add card': 'Aggiungi scheda',
    'Card added to board': 'Scheda aggiunta alla tabella',
    'No empty slots available': 'Nessuno spazio vuoto disponibile',
    'Failed to add card': 'Impossibile aggiungere la scheda',
    'Print all pages': 'Stampa tutte le pagine',
    "Are you sure you want to delete the card(s)? This can't be undone!":
      'Sei sicuro di voler eliminare la carta/le carte? Questo non può essere annullato!',
    'Edit Email': 'Modifica Email',
    'Already exists an user with informed email':
      "Esiste già un utente con l'email fornita",
    'Default Payment': 'Pagamento Predefinito',
    'ending with': 'terminante con',
    'Expires at': 'Scade il',
    'Plan details': 'Dettagli del Piano',
    "Passwords don't match": 'Le password non corrispondono',
    'Password must contain at least one uppercase letter, one lowercase letter, one special character, one number, and have a minimum length of 8 characters':
      'La password deve contenere almeno una lettera maiuscola, una minuscola, un carattere speciale, un numero e avere una lunghezza minima di 8 caratteri',
    'User Already exists': "L'utente esiste già",
    'An email will be sent to activate the account':
      "Un'email verrà inviata per attivare l'account",
    'Expire month': 'Mese di scadenza',
    'Expire year': 'Anno di scadenza',
    'Select as default payment method':
      'Seleziona come metodo di pagamento predefinito',
    'Change Billing': 'Cambia Dati di Fatturazione',
    'Change card details': 'Cambia dettagli della carta',
    activate_license: 'Attiva Licenza',
    'Change Livox Plan': 'Cambia Piano Livox',
    'Due next in': 'Prossima scadenza il',
    'Cancel motive': 'Motivo della cancellazione',
    'Are you sure you want to cancel the plan?':
      'Sei sicuro di voler cancellare il piano?',
    Card: 'Carta',
    'My subscriptions': 'I miei abbonamenti',
    Cards: 'Carte',
    'Welcome to Livox': 'Benvenuto su Livox',
    'enter your e-mail address': 'inserisci il tuo indirizzo email',
    'enter your password': 'inserisci la tua password',
    'Password requirements': 'Requisiti della password',
    'Must be at least 8 characters long':
      'Deve essere lungo almeno 8 caratteri',
    'Must include at least one uppercase letter':
      'Deve includere almeno una lettera maiuscola',
    'Must include at least one lowercase letter':
      'Deve includere almeno una lettera minuscola',
    'Must include at least one number': 'Deve includere almeno un numero',
    'Must include at least one special character':
      'Deve includere almeno un carattere speciale',
    'Old Password': 'Vecchia Password',
    'New Password': 'Nuova Password',
    'enter your old password': 'inserisci la tua vecchia password',
    'enter your new password': 'inserisci la tua nuova password',
    'confirm your new password': 'conferma la tua nuova password',
    'Holder Information': 'Informazioni sul Titolare',
    Client: 'Cliente',
    'My Subscriptions': 'I miei Abbonamenti',
    'Payment Methods': 'Metodi di Pagamento',
    'Payment History': 'Storico dei Pagamenti',
    'Livox Cloud': 'Livox Cloud',
    'of 1TB used': 'di 1TB utilizzati',
    'Portal Livox': 'Portale Livox',
    'CONGRATS!': 'COMPLIMENTI!',
    'Based on your stats you used your account':
      'In base alle tue statistiche hai usato il tuo account',
    'more than last month!': 'più del mese scorso!',
    'Regional Food': 'Cibo Regionale',
    Animals: 'Animali',
    'The Flash Game': 'Il Gioco Flash',
    'All users': 'Tutti gli utenti',
    'All period': 'Tutto il periodo',
    'Last day': 'Ultimo giorno',
    'Last week': 'Ultima settimana',
    'Last month': 'Ultimo mese',
    '1 month': '1 mese',
    'User Stats': 'Statistiche Utente',
    'Play Games': 'Uso dei Giochi',
    'Play Duration': 'Durata di Utilizzo',
    '(minutes)': '(minuti)',
    Recommendations: 'Raccomandazioni',
    'Shared Content': 'Contenuto Condiviso',
    'Total number of minutes:': 'Numero totale di minuti:',
    'Yes or No': 'Sì o No',
    Fruits: 'Frutta',
    Food: 'Cibo',
    'Monthly Usage': 'Utilizzo Mensile',
    'Amount of Interactions': 'Quantità di Interazioni',
    "Oops! It looks like you haven't shared any content yet.":
      'Oops! Sembra che tu non abbia ancora condiviso alcun contenuto.',
    'Edit Your Profile': 'Modifica il Tuo Profilo',
    Appearance: 'Aspetto',
    'Privacy Terms': 'Termini di Privacy',
    'Service Terms': 'Termini di Servizio',
    'Password Settings': 'Impostazioni della Password',
    'For up to 3 users who already know or follow up with Livox professionals.':
      'Per un massimo di 3 utenti che già conoscono o seguono con professionisti di Livox.',
    '/MONTH': '/MESE',
    'Payment Method': 'Metodo di Pagamento',
    IntelliTouch: 'IntelliTouch',
    'Image Dataset': 'Dataset di Immagini',
    'Current Plan': 'Piano Attuale',
    'Other Subscriptions': 'Altri Abbonamenti',
    cancel: 'Annulla',
    cpfOrCnpj: 'CF o CNPJ',
    processing: 'Elaborazione in corso...',
    tryAgainIn: 'Riprova tra {{seconds}}s',
    'BASIC SUBSCRIPTION': 'ABBONAMENTO BASE',
    'Basic Subscription': 'Abbonamento Base',
    'See as list': 'Vedi come lista',
    'See as grid': 'Vedi come griglia',
    'HOW IT WORKS?': 'COME FUNZIONA?',
    '.zip upload': 'carica .zip',
    'create board': 'crea tabellone',
    create: 'crea',
    upload: 'carica',
    feedback: 'feedback',
    'To get started, use Livox Studio to create cards, upload images, music and videos!':
      'Per iniziare, usa Livox Studio per creare schede, caricare immagini, musica e video!',
    'Submit you content to be published in the portal!':
      'Invia il tuo contenuto per essere pubblicato nel portale!',
    'Receive feedback and satisfaction ratings knowing your boards are being used around the world!':
      'Ricevi feedback e valutazioni di soddisfazione sapendo che i tuoi tabelloni vengono utilizzati in tutto il mondo!',
    Price: 'Prezzo',
    OK: 'OK',
    PENDING: 'IN ATTESA',
    DECLINED: 'RIFIUTATO',
    ChangeLivoxPlan: 'Cambia piano Livox',
    'Active Plans': 'Piani Attivi',
    'Canceled Plans': 'Piani Annullati',
    'Are you sure you want to cancel the plan':
      'Sei sicuro di voler annullare il piano?',
    'Plan changed successfully': 'Piano cambiato con successo',
    'Plan cancel successfully': 'Piano annullato con successo',
    'Provide the reason for cancellation':
      'Fornisci il motivo della cancellazione',
    CHANGE: 'CAMBIA',
    paid: 'pagato',
    open: 'aperto',
    draft: 'bozza',
    void: 'annullato',
    declined: 'rifiutato',
    uncollectible: 'inesigibile',
    Invoices: 'Fatture',
    'Wrong password.': 'Password errata.',
    "The two password fields didn't match.":
      'I due campi password non corrispondono.',
    'Something went wrong.': 'Qualcosa è andato storto.',
    'Please fill in all required fields.':
      'Si prega di compilare tutti i campi obbligatori.',
    'Password changed successfully!': 'Password cambiata con successo!',
    'Device Nickname': 'Soprannome del Dispositivo',
    'License Information': 'Informazioni sulla Licenza',
    to: 'a',
    'Licenses per page': 'Licenze per pagina',
    'Choose a payment method': 'Scegli un metodo di pagamento',
    'Published Content': 'Contenuto Pubblicato',
    'View published content in the store':
      'Visualizza i contenuti pubblicati nel negozio',
    'Payment Method changed successfully':
      'Metodo di pagamento aggiornato con successo',
    'Device removed successfully': 'Dispositivo rimosso con successo',
    'Failed to remove device': 'Rimozione del dispositivo non riuscita',
    Monday: 'Lunedì',
    Tuesday: 'Martedì',
    Wednesday: 'Mercoledì',
    Thursday: 'Giovedì',
    Friday: 'Venerdì',
    Saturday: 'Sabato',
    Sunday: 'Domenica',
    'Evolution of use': "Evoluzione dell'utilizzo",
    'Use by schedule': 'Uso per orari del giorno',
    '(clicks)': '(clic)',
    Responsible: 'Responsabile',
    Birthday: 'Data di Nascita',
    Birthdate: 'Data di Nascita',
    None: 'Nessuno',
    Mild: 'Lieve',
    Moderate: 'Moderato',
    'Severe (Blindness)': 'Grave (Cecità)',
    Good: 'Buono',
    'Severe (Needs switch)': 'Grave (Necessita interruttore)',
    'Few physical limitations': 'Poche limitazioni fisiche',
    'Dificulties in daily activities, requires assistance':
      'Difficoltà nelle attività quotidiane, richiede assistenza',
    'Almost or totally dependent': 'Quasi o totalmente dipendente',
    'Without communicative intent': 'Senza intenzione comunicativa',
    'Does not verbalize, but has communicative intention':
      'Non verbalizza, ma ha intenzione comunicativa',
    'Make sounds': 'Fa suoni',
    'Makes vowel unions': 'Fa unioni di vocali',
    'Speak with very limited vocabulary (5-10 words)':
      'Parla con vocabolario molto limitato (5-10 parole)',
    'Speak with limited vocabulary (10-30 words)':
      'Parla con vocabolario limitato (10-30 parole)',
    'Fully communicative': 'Totalmente comunicativo',
    'Diagnosis Information': 'Informazioni sulla Diagnosi',
    'Fine motor skills': 'Abilità motorie fini',
    'Repetitive movements': 'Movimenti ripetitivi',
    'Hearing impairment': 'Impairment uditivo',
    'Visual impairment': 'Impairment visivo',
    'Current communication': 'Comunicazione attuale',
    'Autonomy level': 'Livello di autonomia',
    Have: 'Ha',
    'Does not have': 'Non ha',
    Yes: 'Sì',
    No: 'No',
    'Customer Admin': 'Amministratore Cliente',
    'Portal Admin': 'Amministratore del Portale',
    'Users per page': 'Utenti per pagina',
    Private: 'Privato',
    Organization: 'Organizzazione',
    'License Usage': 'Utilizzo Licenze',
    'Livox Usage': 'Utilizzo di Livox',
    Amount: 'Quantità',
    Used: 'Utilizzato',
    'Users Status': 'Stato degli Utenti',
    'active users': 'utenti attivi',
    Disability: 'Disabilità',
    'Portal Users': 'Utenti del Portale',
    'Last Validation': 'Ultima Validazione',
    Subscriptions: 'Abbonamenti',
    'Public?': 'Pubblico?',
    'Avaiable?': 'Disponibile?',
    'Searching for boards from all your users':
      'Ricerca di tabelloni da tutti i tuoi utenti',
    'Your filters did not find results':
      'I tuoi filtri non hanno trovato risultati',
    'not found': 'non trovato',
    "It looks like your users haven't created boards yet":
      'Sembra che i tuoi utenti non abbiano ancora creato tabelloni',
    'no boards': 'nessun tabellone',
    'Searching for your boards': 'Ricerca dei tuoi tabelloni',
    'Find boards created by users in your organization here':
      'Trova qui i tabelloni creati dagli utenti nella tua organizzazione',
    'Removing this devices will make the user log out of the app. Are you sure you want to remove {{count}} device?':
      "Rimuovendo questi dispositivi, l'utente uscirà dall'app. Sei sicuro di voler rimuovere {{count}} dispositivo?",
    'Removing this device will make the user log out of the app. Are you sure you want to remove this devices?':
      "Rimuovendo questo dispositivo, l'utente uscirà dall'app. Sei sicuro di voler rimuovere questo dispositivo?",
    '{{count}} devices removed successfully':
      '{{count}} dispositivi rimossi con successo',
    '{{count}} devices failed to be removed':
      'Non è stato possibile rimuovere {{count}} dispositivi',
    'Branch removed successfully': 'Sede rimossa con successo',
    'Failed to remove branch': 'Rimozione della sede non riuscita',
    'Branches moved successfully': 'Sedi spostate con successo',
    'Failed to move branches': 'Spostamento delle sedi non riuscito',
    'Move branches to:': 'Sposta sedi in:',
    Move: 'Sposta',
    'Some selected branches have sub-branches. All sub-branches will also be moved.':
      'Alcune sedi selezionate hanno sotto-sedi. Anche tutte le sotto-sedi verranno spostate.',
    'Parent Branch': 'Sede principale',
    Root: 'Radice',
    'Sub-branch of': 'Sotto-sede di',
    'Branch created successfully!': 'Sede creata con successo!',
    'Email already registered': 'Email già registrata',
    'Branch updated successfully!': 'Sede aggiornata con successo!',
    'Create Branch': 'Crea Sede',
    'Update Branch': 'Modifica Sede',
    'Edit Publication': 'Modifica Pubblicazione',
    'My Assessments': 'Le mie Valutazioni',
    'Assessments Details': 'Dettagli delle Valutazioni',
    Assessment: 'Valutazione',
    'Assessments per page': 'Valutazioni per pagina',
    Finish: 'Termina',
    'General assessment': 'Valutazione Generale',
    'Temporal assessment': 'Valutazione Temporale',
    'Assessment average': 'Media della Valutazione',
    Cognitive: 'Cognitivo',
    Auditory: 'Uditivo',
    Visual: 'Visivo',
    Oral: 'Orale',
    Behaviour: 'Comportamentale',
    Geral: 'Generale',
    'Add comment': 'Aggiungi commento',
    'Enter your comment for this assessment':
      'Inserisci il tuo commento per questa valutazione',
    'Assessment added successfully!': 'Valutazione aggiunta con successo!',
    'Failed to add assessments': 'Aggiunta della valutazione non riuscita',
    'New assessment': 'Nuova Valutazione',
    'Customer Support': 'Supporto Clienti',
    Promoted: 'Promosso',
    Statistics: 'Statistiche',
    Details: 'Dettagli',
    Refuse: 'Rifiuta',
    Approve: 'Approva',
    'Content Details': 'Dettagli del Contenuto',
    'boards per page': 'tabelloni per pagina',
    'Searching for pending content...': 'Ricerca di contenuti in sospeso...',
    'Searching for promoted content...': 'Ricerca di contenuti promossi...',
    'Searching for published content...': 'Ricerca di contenuti pubblicati...',
    Created: 'Creato',
    Demote: 'Declassa',
    'Demote Publication': 'Declassa Pubblicazione',
    'Do you want to demote this content?': 'Vuoi declassare questo contenuto?',
    'Approve Publication': 'Approva Pubblicazione',
    'Do you approve this publication?': 'Approvi questa pubblicazione?',
    'Original language': 'Lingua originale',
    'Translate into (optional)': 'Traduci in (facoltativo)',
    'The board was written in this language, not the one it was submitted as — the existing content will be relabeled, not translated.':
      'La scheda è stata scritta in questa lingua, non in quella indicata durante l’invio. Il contenuto esistente verrà rietichettato, non tradotto.',
    'Reject Publication': 'Rifiuta Pubblicazione',
    'Enter the comment for this rejection':
      'Inserisci il commento per questo rifiuto',
    'Remove Publication': 'Rimuovi Pubblicazione',
    'Download count': 'Conteggio download',
    'Successfully promoted!': 'Promosso con successo!',
    'An error occurred while promoting.':
      'Si è verificato un errore durante la promozione.',
    'Upload a banner to promote this board.':
      'Carica un banner per promuovere questa lavagna.',
    'Successfully published board!': 'Tabellone pubblicato con successo!',
    'Successfully updated board!!': 'Tabellone aggiornato con successo!',
    'An error occurred while submitting.':
      "Si è verificato un errore durante l'invio.",
    'Increase the description to at least 10 characters.':
      'Estendi la descrizione ad almeno 10 caratteri.',
    'Publish board': 'Pubblica la scheda',
    'Board submitted for review!': 'Scheda inviata per la revisione!',
    'Please upload a cover image.': "Carica un'immagine di copertina.",
    'The board will be reviewed by an administrator before it appears in the store.':
      'La scheda sarà esaminata da un amministratore prima di apparire nello store.',
    'Enter description': 'Inserisci una descrizione',
    'Enter title': 'Inserisci il titolo',
    'Enter subtitle': 'Inserisci il sottotitolo',
    Subtitle: 'Sottotitolo',
    'Email successfully sent!!!': 'Email inviata con successo!!!',
    'Error sending email!': "Errore nell'invio dell'email!",
    'The content has been demoted!': 'Il contenuto è stato declassato!',
    'Failed to demote content!': 'Declassamento del contenuto non riuscito!',
    'Publication successfully approved!':
      'Pubblicazione approvata con successo!',
    'Failed to approve!': 'Approvazione non riuscita!',
    'Publication successfully rejected!':
      'Pubblicazione rifiutata con successo!',
    'Failed to reject!': 'Rifiuto non riuscito!',
    Activity: 'Attività',
    'License Activity': 'Attività delle Licenze',
    'Active Licenses': 'Licenze Attive',
    'Inactive Licenses': 'Licenze Inattive',
    'User Activity': 'Attività degli Utenti',
    'Removing this sponsor will revoke access to the dashboard and clear all licenses assigned to them.':
      "Rimuovendo questo sponsor si revocherà l'accesso alla dashboard e si cancelleranno tutte le licenze assegnate.",
    'Are you sure you want to delete this sponsor?':
      'Sei sicuro di voler eliminare questo sponsor?',
    'The sponsor has been deleted!': 'Lo sponsor è stato eliminato!',
    'Failed to remove sponsor!': 'Rimozione dello sponsor non riuscita!',
    'Sponsor created successfully!': 'Sponsor creato con successo!',
    'Create Sponsor': 'Crea Sponsor',
    'enter sponsor name...': 'inserisci il nome dello sponsor...',
    'enter email...': "inserisci l'email...",
    'New Sponsor': 'Nuovo Sponsor',
    Sponsors: 'Sponsor',
    'Projects Details': 'Dettagli dei Progetti',
    'Project Dashboard': 'Dashboard del Progetto',
    'Sponsors per page': 'Sponsor per pagina',
    'Assign Licenses': 'Assegna Licenze',
    '{{count}} licenses successfully assigned':
      '{{count}} licenze assegnate con successo',
    'Failed to assign licenses': 'Assegnazione delle licenze non riuscita',
    'Assign licenses to sponsor': 'Assegna licenze allo sponsor',
    'Sponsor Licenses': 'Licenze dello Sponsor',
    'Sponsored Projects': 'Progetti Sponsorizzati',
    'Remove Licenses': 'Rimuovi Licenze',
    'Remove licenses from sponsor': 'Rimuovi licenze dallo sponsor',
    '{{count}} licenses successfully removed':
      '{{count}} licenze rimosse con successo',
    'Failed to remove licenses': 'Rimozione delle licenze non riuscita',
    'Create Portal User': 'Crea Utente del Portale',
    'enter first name...': 'inserisci il nome...',
    'enter last name...': 'inserisci il cognome...',
    'enter a password...': 'inserisci una password...',
    'You do not have active plans': 'Non hai piani attivi',
    'You do not have canceled plans': 'Non hai piani cancellati',
    'searching for your payment methods':
      'ricerca dei tuoi metodi di pagamento',
    'You have no payment methods': 'Non hai metodi di pagamento',
    failed: 'fallito',
    'Your token is invalid or has expired':
      'Il tuo token è invalido o è scaduto',
    'Password does not meet the minimum security requirements':
      'La password non soddisfa i requisiti minimi di sicurezza.',
    'Passwords do not match.': 'Le password non corrispondono.',
    'Resetting...': 'Reimpostazione in corso...',
    'validating your token': 'validazione del tuo token',
    'Password successfully changed!': 'Password cambiata con successo!',
    'Error changing password!': 'Errore nel cambiare la password!',
    'enter branch name': 'inserisci il nome della sede',
    'enter branch address': "inserisci l'indirizzo della sede",
    'enter customer name': 'inserisci il nome del cliente',
    'enter customer address': "inserisci l'indirizzo del cliente",
    'enter city': 'inserisci la città',
    'enter zip code': 'inserisci il CAP',
    'enter state': 'inserisci lo stato',
    'enter phone number': 'inserisci il numero di telefono',
    'Unauthorized Access': 'Accesso non autorizzato',
    'You do not have permission to view this page with your current role.':
      'Non hai il permesso di visualizzare questa pagina con il tuo ruolo attuale.',
    'Page Not Found': 'Pagina non trovata',
    'Sorry, the page you are looking for doesn’t exist.':
      'Spiacenti, la pagina che stai cercando non esiste.',
    'Este campo não pode ser em branco.': 'Questo campo non può essere vuoto.',
    'no licenses': 'nessuna licenza',
    'You do not have any licenses available.': 'Non hai licenze disponibili.',
    licenses: 'licenze',
    users: 'utenti',
    Quantity: 'Quantità',
    Indicator: 'Indicatore',
    Value: 'Valore',
    Category: 'Categoria',
    Aggregate: 'Aggrega',
    'Customers per page': 'Clienti per pagina',
    'Holders per page': 'Titolari per pagina',
    'Searching for your licenses': 'Ricerca delle tue licenze',
    'There are no promoted boards': 'Non ci sono tabelloni promossi',
    'There are no pending boards': 'Non ci sono tabelloni in sospeso',
    'No data was found for this chart.':
      'Nessun dato trovato per questo grafico.',
    Sponsor: 'Sponsor',
    'My Projects': 'I miei Progetti',
    'Invalid Date': 'Data non valida',
    'Organization Details': "Dettagli dell'Organizzazione",
    'All Licenses': 'Tutte le Licenze',
    'All License Types': 'Tutti i Tipi di Licenza',
    'Select Branch': 'Seleziona Sede',
    'Unlink Licenses': 'Scollega Licenze',
    'Unlink License': 'Scollega Licenza',
    'Licenses transferred with success!': 'Licenze trasferite con successo!',
    'Error in transfer!': 'Errore nel trasferimento!',
    'An unexpected error occurred!': 'Si è verificato un errore imprevisto!',
    'Transfer licenses to:': 'Trasferisci licenze a:',
    'When deleting this user from the Portal, they will remain available on your Livox tablet. If you don’t want this user’s data to be sent back to the Portal, delete them from your tablet as well.':
      'Eliminando questo utente dal Portale, rimarranno disponibili sul tuo tablet Livox. Se non desideri che i dati di questo utente vengano inviati nuovamente al Portale, eliminagli anche dal tuo tablet.',
    'The Livox User has been deleted!': "L'utente Livox è stato eliminato!",
    'Failed to remove Livox User!': "Rimozione dell'utente Livox non riuscita!",
    'Delete Livox User': 'Elimina Utente Livox',
    'Are you sure you want to delete this livox user?':
      'Sei sicuro di voler eliminare questo utente Livox?',
    'Activate with QRCode': 'Attiva con QRCode',
    'Enter a valid holder email': "Inserisci un'email del titolare valida",
    'To activate this license, enter the email of an associated holder.':
      "Per attivare questa licenza, inserisci l'email di un titolare associato.",
    'Holder Email': 'Email del Titolare',
    'Invalid email or not associated with this license.':
      'Email invalida o non associata a questa licenza.',
    Validate: 'Valida',
    'Activate with QRCode in your Livox app':
      'Attiva con QRCode nella tua app Livox',
    Distributor: 'Distributore',
    'Distributor Admin': 'Amministratore del Distributore',
    'Distributor Support': 'Supporto del Distributore',
    'Create Support Area': 'Crea Area di Supporto',
    'enter support area name...': "inserisci il nome dell'area di supporto...",
    'Support area created successfully!':
      'Area di Supporto creata con successo!',
    'Removing this support area will only unlink customers and users from this area.':
      "Rimuovere questa area di supporto scollegherà solo clienti e utenti da quest'area.",
    'Are you sure you want to delete this support area?':
      'Sei sicuro di voler eliminare questa area di supporto?',
    'The support area has been deleted!':
      "L'area di supporto è stata eliminata!",
    'Failed to remove support area!':
      "Rimozione dell'area di supporto non riuscita!",
    'Support Area Users': "Utenti dell'Area di Supporto",
    'Remove Users': 'Rimuovi Utenti',
    'Remove users from support area': "Rimuovi utenti dall'area di supporto",
    'Failed to remove users': 'Rimozione degli utenti non riuscita',
    'Select Users': 'Seleziona Utenti',
    '{{count}} users successfully removed':
      '{{count}} utenti rimossi con successo',
    'Support Area Customers': "Clienti dell'Area di Supporto",
    'Select Customers': 'Seleziona Clienti',
    'Customers added successfully!': 'Clienti aggiunti con successo!',
    'Remove Customers': 'Rimuovi Clienti',
    '{{count}} customers successfully removed':
      '{{count}} clienti rimossi con successo',
    'Failed to remove customers': 'Rimozione dei clienti non riuscita',
    'Remove customers from support area':
      "Rimuovi clienti dall'area di supporto",
    Add: 'Aggiungi',
    'Support Areas per page': 'Aree di Supporto per pagina',
    'Created at': 'Creato il',
    'Confirm delete': 'Conferma eliminazione',
    'Android Versions': 'Versioni Android',
    'Create Android Version': 'Crea versione Android',
    'Edit Android Version': 'Modifica versione Android',
    'New Android Version': 'Nuova versione Android',
    'Android version created successfully!':
      'Versione Android creata con successo!',
    'Android version updated successfully!':
      'Versione Android aggiornata con successo!',
    'The android version has been deleted!':
      'La versione Android è stata eliminata!',
    'Failed to remove android version!':
      'Impossibile rimuovere la versione Android!',
    'Are you sure you want to delete this android version?':
      'Sei sicuro di voler eliminare questa versione Android?',
    'Android Versions per page': 'Versioni Android per pagina',
    Resellers: 'Rivenditori',
    'Create Reseller': 'Crea rivenditore',
    'Edit Reseller': 'Modifica rivenditore',
    'New Reseller': 'Nuovo rivenditore',
    'enter reseller name...': 'inserisci il nome del rivenditore...',
    'Reseller created successfully!': 'Rivenditore creato con successo!',
    'Reseller updated successfully!': 'Rivenditore aggiornato con successo!',
    'The reseller has been deleted!': 'Il rivenditore è stato eliminato!',
    'Failed to remove reseller. Make sure there are no licenses linked to it before deleting.':
      'Impossibile rimuovere il rivenditore. Assicurarsi che non ci siano licenze collegate prima di eliminarlo.',
    'Are you sure you want to delete this reseller?':
      'Sei sicuro di voler eliminare questo rivenditore?',
    'Resellers per page': 'Rivenditori per pagina',
    'Payment QR Code': 'QR Code pagamento',
    'Payment link for {{name}}': 'Link di pagamento per {{name}}',
    'Payment link': 'Link di pagamento',
    'User created successfully!': 'Utente creato con successo!',
    Spanish: 'Spagnolo',
    'Billing user does not exist': "L'utente per la fatturazione non esiste",
    French: 'Francese',
    Italian: 'Italiano',
    'Our website has been updated to improve your experience. To ensure proper functionality, we recommend clearing your browser cache. If you are using the Livox app version 5, please close and reopen the app to ensure proper connection to your account.':
      "Il nostro sito web è stato aggiornato per migliorare la tua esperienza. Per garantire il corretto funzionamento, ti consigliamo di svuotare la cache del browser. Se stai utilizzando la versione 5 dell'app Livox, chiudi e riapri l'app per garantire la corretta connessione al tuo account.",
    'Website Update': 'Aggiornamento del sito web',
    'Reload page': 'Ricarica pagina',
    "Don't show again": 'Non mostrare di nuovo',
    'enter email': 'inserisci email',
    'Customer created successfully!': 'Cliente creato con successo!',
    'Enter a valid email address': 'Inserisci un indirizzo email valido',
    'Only letters are allowed': 'Sono consentite solo lettere',
    'enter number of devices': 'inserisci il numero di dispositivi',
    'enter text': 'inserisci testo',
    'enter install key...': 'inserisci la chiave di installazione...',
    'enter device name...': 'inserisci il nome del dispositivo...',
    'enter device nickname...': 'inserisci il soprannome del dispositivo...',
    'enter device MAC address...':
      "inserisci l'indirizzo MAC del dispositivo...",
    'Device MAC Address': 'Indirizzo MAC del Dispositivo',
    'Licenses created successfully!': 'Licenze create con successo!',
    Payment: 'Pagamento',
    'Registration link generated successfully!':
      'Link di registrazione generato con successo!',
    'Failed to generate registration link.':
      'Generazione del link di registrazione non riuscita.',
    'Copy Link': 'Copia Link',
    'Link copied to clipboard!': 'Link copiato negli appunti!',
    '{{diff}} year(s) ago': '{{diff}} anno(i) fa',
    '{{diff}} month(s) ago': '{{diff}} mese(i) fa',
    '{{diff}} day(s) ago': '{{diff}} giorno(i) fa',
    '{{diff}} hour(s) ago': '{{diff}} ora(e) fa',
    '{{diff}} minute(s) ago': '{{diff}} minuto(i) fa',
    'Holder registered successfully!': 'Titolare registrato con successo!',
    'Register Holder': 'Registrare Titolare',
    'enter address': 'inserisci indirizzo',
    'confirm your password': 'conferma la tua password',
    'Passwords must match': 'Le password devono corrispondere',
    'Professional Type': 'Tipo Professionale',
    'Speech Therapist': 'Logopedista',
    'Occupational Therapist': 'Terapista Occupazionale',
    Physiotherapist: 'Fisioterapista',
    Teacher: 'Insegnante',
    Pedagogue: 'Pedagogista',
    Psychopedagogue: 'Psicopedagogista',
    Other: 'Altro',
    'Error loading subscription details':
      'Errore nel caricamento dei dettagli della sottoscrizione',
    Activation: 'Attivazione',
    Cancellation: 'Cancellazione',
    'Due Date': 'Data di Scadenza',
    'Payment Link': 'Link di Pagamento',
    Receipt: 'Recibo',
    'View Receipt': 'Visualizza Recibo',
    'Invoice Date': 'Data della Fattura',
    Paid: 'Pagato',
    'Invoice Status': 'Stato della Fattura',
    'Receipt Link': 'Link del Recibo',
    'Status updated successfully': 'Stato aggiornato con successo',
    'Failed to update license status': 'Aggiornamento dello stato non riuscito',
    'Edit License': 'Modifica Licenza',
    'Are you sure you want to delete this license?':
      'Sei sicuro di voler eliminare questa licenza?',
    'Are you sure you want to delete license':
      'Sei sicuro di voler eliminare la licenza',
    'This will delete all licenses with install key: {{installKey}}':
      'Questo eliminerà tutte le licenze con la chiave di installazione: {{installKey}}',
    'Permanently delete the license(s)':
      'Elimina permanentemente la(le) licenza(e)',
    'License deleted successfully!': 'Licenza eliminata con successo!',
    'Failed to delete license!': 'Eliminazione della licenza non riuscita!',
    'License updated successfully!': 'Licenza aggiornata con successo!',
    'Failed to update license!': 'Aggiornamento della licenza non riuscito!',
    'No changes to save': 'Nessuna modifica da salvare',
    'Are you sure you want to update all licenses?':
      'Sei sicuro di voler aggiornare tutte le licenze?',
    'This will update all licenses with install key':
      'Questo aggiornerà tutte le licenze con la chiave di installazione',
    'Update install key to': 'Aggiorna chiave di installazione a',
    'Update type to': 'Aggiorna tipo a',
    'All licenses with this install key will be affected!':
      'Tutte le licenze con questa chiave di installazione saranno interessate!',
    'Click here': 'Clicca qui',
    Donation: 'Donazione',
    Sale: 'Vendita',
    Evaluation: 'Valutazione',
    Research: 'Ricerca',
    'Old Version (BETA TEST)': 'Vecchia Versione (TEST BETA)',
    Developer: 'Sviluppatore',
    Representative: 'Rappresentante',
    'Resale Channel': 'Canale di Rivendita',
    'Are you sure you want to unblock this customer?':
      'Sei sicuro di voler desbloquear questo cliente?',
    'Are you sure you want to block this customer?':
      'Sei sicuro di voler bloccare questo cliente?',
    Block: 'Blocca',
    'Change Status': 'Cambia Stato',
    'Are you sure you want to change the status?':
      'Sei sicuro di voler cambiare lo stato?',
    Select: 'Seleziona',
    'Unit manager': 'Responsabile unità',
    'type to search': 'digita per cercare',
    'Manager e-mail': 'E-mail del responsabile',
    'Create user': 'Crea utente',
    'Cancel user creation': 'Annulla creazione utente',
    'Select existing user': 'Seleziona utente esistente',
    'enter password': 'inserisci password',
    'confirm password': 'conferma password',
    'Select a manager or create a new user':
      'Seleziona un responsabile o crea un nuovo utente',
    'Email not found. Click Create user':
      'E-mail non trovata. Clicca su Crea utente',
    'This email already exists. Select an existing user':
      'Questa e-mail esiste già. Seleziona un utente esistente',
    'Customer email already registered.':
      "L'e-mail del cliente è già registrata.",
    'Email is required': 'E-mail è obbligatoria',
    'Invalid value': 'Valore non valido',
    'This field is required': 'Questo campo è obbligatorio',
    'Password is required': 'Password è obbligatoria',
    'Confirm Exit': 'Conferma uscita',
    'Are you sure you want to exit? Any unsaved changes will be lost.':
      'Sei sicuro di voler uscire? Tutte le modifiche non salvate andranno perse.',
    Export: 'Esporta',
    'Export Charts': 'Esporta Grafici',
    'Export Charts to PDF': 'Esporta Grafici in PDF',
    'Export Data': 'Esporta Dati',
    'Exporting...': 'Esportazione...',
    'No data to export': 'Nessun dato da esportare',
    'No charts found to export': 'Nessun grafico trovato da esportare',
    'File exported successfully': 'File esportato con successo',
    'Charts exported successfully': 'Grafici esportati con successo',
    'Export successful!': 'Esportazione riuscita!',
    'Export failed!': 'Esportazione fallita!',
    'Error exporting file': "Errore durante l'esportazione del file",
    'Error exporting charts': "Errore durante l'esportazione dei grafici",
    'Are you sure you want to delete this user?':
      'Sei sicuro di voler eliminare questo utente?',
    'Are you sure you want to delete user':
      "Sei sicuro di voler eliminare l'utente",
    'This action will:': 'Questa azione:',
    'Unlink all licenses from the user holder':
      "Scollegherà tutte le licenze dal titolare dell'utente",
    'Delete the associated holder (if exists)':
      'Eliminerà il titolare associato (se esiste)',
    'Remove user from all groups': "Rimuoverà l'utente da tutti i gruppi",
    'Delete all Livox Users linked to this user':
      'Eliminerà tutti gli Utenti Livox collegati a questo utente',
    'Permanently delete the user account':
      "Eliminerà definitivamente l'account utente",
    'This action cannot be undone!': 'Questa azione non può essere annullata!',
    'User updated successfully!': 'Utente aggiornato con successo!',
    'User deleted successfully!': 'Utente eliminato con successo!',
    '{{count}} licenses unlinked.': '{{count}} licenze scollegate.',
    'Holder deleted.': 'Titolare eliminato.',
    'Failed to delete user!': "Impossibile eliminare l'utente!",
    'Changing password for user': "Cambio password per l'utente",
    'enter new password...': 'inserisci nuova password...',
    'confirm new password...': 'conferma nuova password...',
    'Update Password': 'Aggiorna Password',
    'Password updated successfully!': 'Password aggiornata con successo!',
    'confirm your password...': 'conferma la tua password...',
    'Edit Portal User': 'Modifica Utente del Portale',
    'User Details': 'Dettagli Utente',
    'Personal Data': 'Dati Personali',
    'View Details': 'Visualizza Dettagli',
    'View Holder Details': 'Visualizza Dettagli del Titolare',
    'View Boards': 'Visualizza Schede',
    'View Content Store': 'Visualizza Negozio di Contenuti',
    'Created boards': 'Schede create',
    Total: 'Totale',
    'Published boards': 'Schede pubblicate',
    'No holder linked': 'Nessun titolare collegato',
    'No customer linked': 'Nessun cliente collegato',
    'User Boards': 'Schede Utente',
    'View boards created by this user':
      'Visualizza le schede create da questo utente',
    'Customer not found': 'Cliente non trovato',
    'Loading boards': 'Caricamento schede',
    "This user hasn't created any boards yet":
      'Questo utente non ha ancora creato schede',
    'Create Holder': 'Crea Titolare',
    'Edit Holder': 'Modifica Titolare',
    'Holder created successfully!': 'Titolare creato con successo!',
    'No user found for this email. Fill in the fields below to create a new holder user.':
      'Nessun utente trovato per questa email. Compila i campi sottostanti per creare un nuovo utente titolare.',
    'Holder updated successfully!': 'Titolare aggiornato con successo!',
    'Holder deleted successfully!': 'Titolare eliminato con successo!',
    'Are you sure you want to delete this holder?':
      'Sei sicuro di voler eliminare questo titolare?',
    'Are you sure you want to delete holder':
      'Sei sicuro di voler eliminare il titolare',
    'Release all licenses from this holder':
      'Rilasciare tutte le licenze da questo titolare',
    'Permanently delete the holder': 'Eliminare definitivamente il titolare',
    '{{count}} licenses released.': '{{count}} licenze rilasciate.',
    'Failed to delete holder!': 'Impossibile eliminare il titolare!',
    'User is required': "L'utente è obbligatorio",
    'Country is required': 'Il paese è obbligatorio',
    'Zipcode is required': 'Il codice postale è obbligatorio',
    'Phone number is required': 'Il numero di telefono è obbligatorio',
    'enter zipcode...': 'inserisci codice postale...',
    'enter address...': 'inserisci indirizzo...',
    'enter city...': 'inserisci città...',
    'enter state...': 'inserisci stato...',
    'enter phone number...': 'inserisci numero di telefono...',
    'enter professional record...': 'inserisci registro professionale...',
    'Professional Record': 'Registro Professionale',
    'Holder Details': 'Dettagli del Titolare',
    'Professional Information': 'Informazioni Professionali',
    'No licenses linked': 'Nessuna licenza collegata',
    'Livox User Details': "Dettagli dell'Utente Livox",
    'Personal Information': 'Informazioni Personali',
    'Health Information': 'Informazioni sulla Salute',
    'Contact Information': 'Informazioni di Contatto',
    'Responsible Information': 'Informazioni del Responsabile',
    'Responsible 1 Name': 'Nome del Responsabile 1',
    'Responsible 1 Email': 'E-mail del Responsabile 1',
    'Responsible 1 Phone': 'Telefono del Responsabile 1',
    'Responsible 2 Name': 'Nome del Responsabile 2',
    'Responsible 2 Email': 'E-mail del Responsabile 2',
    'Responsible 2 Phone': 'Telefono del Responsabile 2',
    'Autonomy Level': 'Livello di Autonomia',
    'Current Communication': 'Comunicazione Attuale',
    'Visual Impairment': 'Deficit Visivo',
    'Fine Motor Skills': 'Abilità Motorie Fini',
    'Repetitive Movements': 'Movimenti Ripetitivi',
    'Hearing Impairment': 'Deficit Uditivo',
    'No data available': 'Nessun dato disponibile',
    'Edit Livox User': "Modifica l'Utente Livox",
    Unauthorized: 'Non autorizzato',
    'Board settings': 'Impostazioni della lavagna',
    'Board name and cover': 'Nome e copertina della lavagna',
    'Board name': 'Nome della lavagna',
    'Board cover image': 'Immagine di copertina della lavagna',
    'Board cover': 'Copertina della lavagna',
    'Click the image to change': "Clicca sull'immagine per cambiare",
    'Error uploading image': "Errore durante il caricamento dell'immagine",
    'Error saving title': 'Errore durante il salvataggio del nome',
    'Move cards': 'Sposta le carte',
    'Select cards': 'Seleziona le carte',
    Redo: 'Ripeti',
    Help: 'Aiuto',
    Layout: 'Layout',
    'Board background color': 'Colore di sfondo della lavagna',
    'Card settings': 'Impostazioni delle carte',
    'Fixed bar settings': 'Impostazioni della barra fissa',
    'Lock board horizontal': 'Blocca la lavagna in orizzontale',
    'Auto navigation cards': 'Schede di navigazione automatica',
    back: 'indietro',
    Columns: 'Colonne',
    'Select background color': 'Seleziona il colore di sfondo',
    'General card settings': 'Impostazioni generali delle carte',
    'Show text only': 'Mostra solo il testo',
    'Text position': 'Posizione del testo',
    Bottom: 'Inferiore',
    Top: 'Superiore',
    'Show cards with levels as folders':
      'Mostra le carte con livelli come cartelle',
    'High contrast cards': 'Carte ad alto contrasto',
    'Black and white cards': 'Carte in bianco e nero',
    IntelliBar: 'IntelliBar',
    'Enable IntelliBar': 'Attiva IntelliBar',
    'IntelliBar description':
      "Se abilitata, Livox mostrerà una barra nella parte superiore dello schermo in cui l'utente può creare frasi. Questa funzione richiede il download della lavagna delle carte di conversazione IntelliBar se non l'hai già fatto.",
    'IntelliBar screen size': 'Dimensione IntelliBar sullo schermo',
    'Speak card when adding to IntelliBar':
      'Leggi la carta quando la aggiungi a IntelliBar',
    Disabled: 'Disabilitato',
    Enabled: 'Abilitato',
    'Partially enabled': 'Parzialmente abilitato',
    intelibar_speak_disabled_desc:
      'Livox parlerà solo toccando il pulsante parla della IntelliBar.',
    intelibar_speak_partial_desc:
      'Livox pronuncerà la carta toccata inserita nella IntelliBar.',
    intelibar_speak_full_desc: 'Livox pronuncerà tutte le carte toccate.',
    'Speak card before adding': 'Leggi la carta prima di aggiungere',
    'Speak card after adding': 'Leggi la carta dopo aver aggiunto',
    'Show only card text in IntelliBar':
      'Mostra solo il testo della carta in IntelliBar',
    'Enable fixed bar': 'Attiva barra fissa',
    'Fixed bar scroll up': 'Scorri la barra fissa verso l’alto',
    'Fixed bar scroll down': 'Scorri la barra fissa verso il basso',
    'Fixed bar scroll left': 'Scorri la barra fissa a sinistra',
    'Fixed bar scroll right': 'Scorri la barra fissa a destra',
    'Fixed bar limit reached': 'Limite della barra fissa raggiunto',
    Position: 'Posizione',
    Side: 'Laterale',
    'Visible cards count': 'Numero di carte visibili',
    'Show as folder': 'Mostra come cartella',
    'Select card bar color': 'Seleziona il colore della barra delle carte',
    'Create a Card': 'Crea una carta',
    Image: 'Immagine',
    'Text/Spoken text': 'Testo / testo parlato',
    'Color Background': 'Colore di sfondo',
    'Add media': 'Aggiungi media',
    'Image Bank': 'Banca immagini',
    'Search image': 'Cerca immagine',
    'Starts with': 'Inizia con',
    'Card title': 'Titolo della carta',
    'Spoken Text': 'Testo parlato',
    'Letters; Numbers': 'Lettere; numeri',
    'Text/Spoken Text': 'Testo / Testo parlato',
    card_title_description: 'Questo testo verrà mostrato sulla carta.',
    'Spoken text': 'Testo parlato',
    spoken_text_description:
      'Questo testo verrà letto. Puoi scrivere testi lunghi se vuoi.',
    'Text font': 'Font del testo',
    'Text color': 'Colore del testo',
    'Background Color': 'Colore di sfondo',
    'Background color card': 'Colore di sfondo della carta',
    'Card border color': 'Colore del bordo della carta',
    'Attach a media': 'Allega un media',
    'No media': 'Nessun media',
    'Record an audio': 'Registra un audio',
    'Pick an audio': 'Scegli un audio',
    'Pick a video': 'Scegli un video',
    'Cards Properties': 'Proprietà delle carte',
    'Show just text': 'Mostra solo testo',
    show_just_text_desc:
      'Se abilitato, Livox non mostrerà più le carte con immagine',
    'Large size images': 'Immagini di grandi dimensioni',
    large_images_desc: 'Se abilitato, le carte appariranno più grandi',
    'Keep the card unchanged': 'Mantieni la carta invariata',
    keep_unchanged_desc:
      'Questa carta non subirà modifiche sulle lavagne con valori predefiniti',
    'Display card in folder format': 'Mostra la carta in formato cartella',
    'Card Title': 'Titolo della carta',
    'Upload Card': 'Carica carta',
    'Board layout': 'Layout della lavagna',
    'Maintain relative positioning': 'Mantieni posizionamento relativo',
    help_move: 'Abilita per trascinare e riordinare le carte sulla lavagna.',
    help_select: 'Abilita per selezionare più carte contemporaneamente.',
    help_yesno: 'Abilita per aggiungere pulsanti Sì/No sulle carte.',
    help_undo_redo: 'Annulla o ripeti le modifiche alle impostazioni.',
    help_play_mode:
      'Apre la tavola a schermo intero per usarla davvero: naviga tra carte e cartelle, componi frasi e ascoltale.',
    help_export_pdf:
      'Esporta la tavola corrente come file PDF da stampare o condividere.',
    help_ia:
      "Usa l'intelligenza artificiale per suggerire le carte automaticamente.",
    'Card actions': 'Azioni della carta',
    Interests: 'Interessi',
    'Android ID': 'Android ID',
    'Advanced Filters': 'Filtri Avanzati',
    'Apply Filters': 'Applica Filtri',
    'Clear All': 'Cancella Tutto',
    Order: 'Ordina',
    Ascending: 'Crescente',
    Descending: 'Decrescente',
    From: 'Da',
    To: 'A',
    All: 'Tutti',
    Information: 'Informazioni',
    Location: 'Posizione',
    Keys: 'Chiavi',
    'Date of Birth': 'Data di Nascita',
    'Activated Licenses': 'Licenze Attivate',
    'Inactivated Licenses': 'Licenze Disattivate',
    Options: 'Opzioni',
    Hide: 'Nascondi',
    Show: 'Mostra',
    'Enter sublevel': 'Entra nel sottolivello',
    'Create folder': 'Crea cartella',
    'Edit Card': 'Modifica scheda',
    'Add state': 'Aggiungi stato',
    'Cannot access cards with more than one state':
      'Impossibile accedere a carte con più di uno stato.',
    'Cards with sublevels cannot have multiple states':
      'Le carte con sottolivelli non possono avere più stati.',
    Untitled: 'Senza titolo',
    'No states yet. Add one below.':
      'Nessuno stato ancora. Aggiungine uno di seguito.',
    'Generate image': 'Genera immagine',
    'Enter image prompt...': 'Inserisci un prompt immagine...',
    'Image style': 'Stile immagine',
    'Download image': 'Scarica immagine',
    Contains: 'Contiene',
    'Type to search symbols': 'Digita per cercare simboli',
    'Save failed': 'Salvataggio fallito',
    'Choose file from computer': 'Scegli file dal computer',
    Upload: 'Carica',
    'Upload failed': 'Caricamento fallito',
    'Select from image bank': 'Seleziona dalla banca immagini',
    'Generate with AI': 'Genera con IA',
    Generated: 'Generata',
    'Upload an image from your device':
      "Carica un'immagine dal tuo dispositivo",
    'Choose a symbol from the image bank':
      'Scegli un simbolo dalla banca immagini',
    Selected: 'Selezionato',
    'Unsaved image selected': 'Immagine non salvata selezionata',
    'Upload image from computer': 'Carica immagine dal computer',
    'Select an image before saving the card.':
      "Seleziona un'immagine prima di salvare la scheda.",
    'Book Settings': 'Impostazioni libro',
    'Text size': 'Dimensione testo',
    'Highlight spoken text': 'Evidenzia il testo parlato',
    Exit: 'Esci',
    'Start over': "Ricomincia dall'inizio",
    'To enable Book Mode, add cards to the board':
      'Per attivare la Modalità Libro, aggiungi schede alla tavola',
    'Deactivate Book Mode to create sublevels':
      'Disattiva la Modalità Libro per creare sottolivelli',
    'Continue from page {{page}}': 'Continua dalla pagina {{page}}',
    'Open at page {{page}}': 'Apri alla pagina {{page}}',
    'To enable Book Mode, add child cards':
      'Per attivare la Modalità Libro, aggiungi schede figlie',
    'This book has no pages': 'Questo libro non ha pagine',
  },
}
